import React, {useEffect} from 'react'
import t from 'helpers/I18n'
import PropTypes from 'prop-types'
import BaseParagraph from "components/base-components/base-paragraph";
import illustration from "components/../assets/png/404.png"
import BaseButton from "components/base-components/base-button";
import StepsWrapper from "steps/steps-wrapper";
import StepsLoader from "steps/steps-loader";
import { AppDataContext } from '../../contexts/app-data';
const PageBus = window.PageBus


const Error404 = () => {
    const lang = localStorage.getItem('language')
    const { state, dispatch } = React.useContext(AppDataContext)

useEffect(() => {
        if (PageBus) {
        PageBus.publish("analyticsServices",{
    pageID: "onboarding",
    stepSeq: "5",
    stepName: "error:404:page does not exist",
    flowType: "sales",
    flowName: "onboarding",
    productName: "onboarding",
    trackMethod: "flow"
        });
        }
    }, [])
    return (
        <div className={"intro-step"}>
            {/* <StepsWrapper stepGroupTitle={t('general.open_pro_account')} loaded={0.1} title={t('general.open_pro_account')}> */}
            <StepsWrapper stepGroupTitle={" "} >
                <StepsLoader>

                    <BaseParagraph  illustration={illustration} />
                    <BaseParagraph  align={"center"} >
                        <h3>{t('errors_sreans.404.title')}</h3>
                        <p>{t('errors_sreans.404.Text')}</p>
                    </BaseParagraph>

                    <div className={"footer-action"} style={{bottom: state.footer_height}}>
                        <BaseButton caption={t('general.continue')} link={`/${lang.toLowerCase()}/`}/>
                    </div>
                </StepsLoader>
            </StepsWrapper>
        </div>

    )
}

Error404.propTypes = {
    name: PropTypes.string
}

Error404.defaultProps = {
    name: "Step02"
}


export default Error404